export const loadNavs = (navDivs) => {
  navDivs.forEach((div) => new Nav(div));
};

class Nav {
  constructor(div) {
    this.div = div;
    this.opener = div.querySelector(".nav__opener");
    this.links = div.querySelector(".nav__links");
    this.setupEventListener();
  }

  setupEventListener = () => {
    this.opener.addEventListener("click", this.click);
  };

  click = (e) => {
    e.preventDefault();
    this.links.classList.toggle("active");
  };
}
